import { Box, Grid, Typography, TextField, Button, CircularProgress, Alert } from "@mui/material"
import { useOt } from "../../../../shared/context/otContext"
import { useState, useEffect } from "react"
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import NextPlanRoundedIcon from '@mui/icons-material/NextPlanRounded';
import { useTaskContext } from "../../../../shared/context/taskContext"
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import moment from "moment"

export default function CommentToMoveOt({  toStatus}) {

    const {otSelectToMove, sendOtToReview, loadingSendOtToReview} = useOt()
    const [commentSendOt, setCommentSendOt] = useState("")
    const { getTasks } = useTaskContext() 


    const handleGetTasks = () => {
        //inicia buscando tareas y ots de un mes atras hasta hoy
        const startDate = moment().subtract(1, 'month').startOf('day')
        const endDate = moment().add(3, 'month').endOf('day')
        getTasks({ startDate, endDate })  
    }

 
    return (
        <Box sx={{p: 2}}>
            <Grid container spacing={2}>
                <Grid item size={{xs: 12 }}>

                    {toStatus !== 'in_process' && toStatus !== 'cancel' && (
                        otSelectToMove?.calculate_completed < 100 && toStatus === 'review' ? 
                        <Alert severity="warning" sx={{mb: 2}}>
                            La OT no esta completa. Si la envia a revisión, se contará como incompleta.
                        </Alert> : 
                        <Alert severity="info" sx={{mb: 1}}>
                            { toStatus === 'review' ? 'La OT esta completa y lista para ser enviada a revisión.' : 'La OT será finalizada.'}
                        </Alert>
                    )}

                    {toStatus === 'in_process' && <Alert severity="warning" sx={{mb: 1}}>
                        Estas a punto de regresar la OT a proceso.
                    </Alert>}

                    {toStatus === 'cancel' && <Alert severity="error" sx={{mb: 1}}>
                        Estas a punto de cancelar la OT.
                    </Alert>}

                    
                </Grid>
           
                <Grid item size={{xs: 12 }}>
                    <TextField
                        fullWidth
                        label="Comentario"
                        multiline
                        rows={4}
                        value={commentSendOt}
                        onChange={(e) => setCommentSendOt(e.target.value)}
                    />
                </Grid>

                <Grid item size={{xs: 12 }}>
                    <Button
                        variant="contained"
                        color={toStatus === 'review' ? 'warning' : toStatus === 'in_process' ? 'primary' : toStatus === 'cancel' ? 'error' : 'success'}
                        onClick={() => sendOtToReview(commentSendOt, toStatus, handleGetTasks)}
                        disabled={loadingSendOtToReview || commentSendOt.length === 0}
                        startIcon={loadingSendOtToReview ? <CircularProgress size={20} /> : toStatus === 'review' ? <NextPlanRoundedIcon /> : toStatus === 'in_process' ? <ArrowBackRoundedIcon /> : toStatus === 'cancel' ? <CloseRoundedIcon /> : <CheckCircleRoundedIcon />}
                    >
                        {toStatus === 'review' ? 'Enviar a revisión' : toStatus === 'in_process' ? 'Regresar a proceso' : toStatus === 'cancel' ? 'Cancelar OT' : 'Finalizar OT'}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    )
}